import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Container, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import SimpleBox from "./SimpleBox";
import dayjs from "dayjs";
import { FaFacebook, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa6";
import RegularLink from "../../typography/RegularLink";
import DialogImpersonate from "../../dialog/DialogImpersonate";
import { apiPublicImpersonate } from "../../../api/public";
import { updateFromImpersonate } from "../../../store/user";
import { toast } from "react-toastify";
import ButtonLink from "../../typography/ButtonLink";
import { updateShop } from "../../../store/shop";

const Footer = ({ footerWidth = "lg", mt = 0 }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isAdmin = useSelector(state => state.user.isAdmin);
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();

    const handleUserClick = (action, email) => {

        if (action === "cancel") {
            setOpen(false);
        }

        if (action === "submit") {
            apiPublicImpersonate({ impersonate: email }, (data, successFlag) => {
                if (successFlag > 0) {
                    dispatch(updateFromImpersonate({...data, impersonate: email}));
                    console.log("DATA", data);
                    const orders = Boolean(data.people) && data.people.length > 0 ? data.people.reduce((acc, person) => {
                        acc[person.id] = person.shopOrders;
                        return acc;
                    }, {}) : {};
                    const cart = Boolean(data.people) && data.people.length > 0 ? data.people.reduce((acc, person) => {
                        acc[person.id] = person.cartItems.map(item => {
                            return {
                                amount: item.shopOrder.amount,
                                details: item.shopOrder.details,
                                id: item.shopOrder.id,
                                productId: item.shopOrder.productId,
                                size: item.shopOrder.size,
                                personId: person.id,
                            }
                        });
                        return acc;
                    }, {}) : {};
                    dispatch(updateShop({ orders: orders, cart: cart }));

                    toast.success("Utilizador carregado com sucesso");
                    setOpen(false);
                }
            });
        }
    }

    return (
        <SimpleBox fullWidth={true} flexDirection="column" backgroundColor="raisinBlack" alignItems="center" justifyContent="center" mt={theme.spacing(mt)} pt={10} pb={10}>
            <Container maxWidth={footerWidth}>
                <SimpleBox fullWidth={true} flexDirection="column" gap={4}>
                    <Typography fontSize="1.3rem">Segue-nos nas redes sociais!</Typography>
                    <Box display="flex" gap={theme.spacing(5)} alignItems="center">
                        <Link alignItems="center" href="https://www.facebook.com/AndebolADCB" target="_blank" color={theme.palette.white.main}><FaFacebook size="26px" /></Link>
                        <Link alignItems="center" href="https://www.instagram.com/adcbandebol" target="_blank" color={theme.palette.white.main}><FaInstagram size="26px" /></Link>
                        <Link alignItems="center" href="https://www.youtube.com/@adcbenavente4420" target="_blank" color={theme.palette.white.main}><FaYoutube size="26px" /></Link>
                        <Link alignItems="center" href="https://www.tiktok.com/@adcbandebol" target="_blank" color={theme.palette.white.main}><FaTiktok size="26px" /></Link>
                    </Box>
                    <SimpleBox flexDirection={isMobile ? "column" : "row"} fullWidth={true} justifyContent="left" borderTop={`1px solid ${theme.palette.white.main}`} mt={10} pt={4} gap={4}>
                        <Box color={theme.palette.white.main} fontSize="0.8rem">&copy; {dayjs().year()} ADCB. Todos os direitos reservados.</Box>
                        <RegularLink fontSize="0.8rem" fontColor={theme.palette.white.main} to="/privacy">Política de Privacidade</RegularLink>
                        <RegularLink fontSize="0.8rem" fontColor={theme.palette.white.main} to="/terms">Termos e Condições</RegularLink>
                        { isAdmin ? <ButtonLink onClick={() => setOpen(true)} label="Impersonate" /> : null }
                    </SimpleBox>
                </SimpleBox>
            </Container>
            <DialogImpersonate open={open} actionMethod={handleUserClick} />
        </SimpleBox>
    );
}

export default Footer;
